"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var AppSelectorItem_1 = __importDefault(require("./AppSelectorItem"));
var utils_1 = require("../Auth/utils");
var actions_1 = require("../Auth/actions");
var AppSelectorItems = function (_a) {
    var apps = _a.apps;
    var state = (0, react_redux_1.useSelector)(function (appState) { return appState; });
    var dispatch = (0, react_redux_1.useDispatch)();
    var appsWithRole = apps.filter(function (app) { return matchRoles(state, app.requiredRoles); });
    if (!state.user.authenticated && !state.auth.loading) {
        dispatch((0, actions_1.login)());
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, appsWithRole.map(function (app, i) { return react_1.default.createElement(AppSelectorItem_1.default, { key: i, app: app }); })));
};
function matchRoles(state, roles) {
    if (!roles) {
        return true;
    }
    if (Array.isArray(roles)) {
        return evaluateRoleExpression(state, {
            type: 'and',
            args: roles,
        });
    }
    return evaluateRoleExpression(state, roles);
}
function evaluateRoleExpression(state, e) {
    if (typeof e === 'string') {
        return (0, utils_1.hasRole)(state, e);
    }
    switch (e.type) {
        case 'and':
            return e.args.every(function (arg) { return evaluateRoleExpression(state, arg); });
        case 'or':
            return e.args.some(function (arg) { return evaluateRoleExpression(state, arg); });
    }
}
exports.default = AppSelectorItems;
